import axios from "axios"

const instance = axios.create({
  baseURL: "https://www.googleapis.com/blogger/v3/blogs/8752789290518770344/posts",
});

export default instance;
